/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Zany_Tidy_Eagle_SproutInputs */

const fr_zany_tidy_eagle_sprout = /** @type {(inputs: Zany_Tidy_Eagle_SproutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aucun utilisateur trouvé`)
};

/**

* @param {Zany_Tidy_Eagle_SproutInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const zany_tidy_eagle_sprout = /** @type {((inputs?: Zany_Tidy_Eagle_SproutInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Zany_Tidy_Eagle_SproutInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_zany_tidy_eagle_sprout(inputs)
});